module.exports = {
  daily: 'cainiao.test',
  pre: {
    ali: 'cainiao-inc.com',
    external: 'cainiao.com'
  },
  prod: {
    ali: 'cainiao-inc.com',
    external: 'cainiao.com'
  }
};


// WEBPACK FOOTER //
// ./src/net/whitelist.js